import { Link } from 'react-router-dom';

const Logo = () => (
    <Link to="/">
        <img
            height="57px"
            src="https://cdn.content.careerhub.com.au/UC/component-images/UC_Logo.png"
            alt=""
        />
    </Link>
);

export default Logo;
